import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import { Layout } from '../../../components';
import { FiCamera, FiUpload } from 'react-icons/fi';
import { getMyProfile, uploadMyPic } from '../../../service/usersService';
import { checkImageExists } from '../../../utls/img';
import { MINIO } from '../../../data/data';
import { initialUsers } from '../../../type/users';
import { useNavigate } from 'react-router-dom';
import { showMessage } from '../../../utls/message';

const UploadPic = () => {
    const [users, setUsers] = useState(initialUsers)
    const [selectedImage, setSelectedImage] = useState<string>("/assets/imgs/no-user-image-icon.jpg");
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [imageExists, setImageExists] = useState(false);
    const [image, setImage] = useState<{ preview: string; raw: File | null }>({
        preview: '',
        raw: null,
    });

    const navigate = useNavigate();

    const handleImageChange = (e: ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];

        if (file) {
            const reader = new FileReader();

            reader.onloadend = () => {
                setSelectedImage(reader.result as string);
            };

            reader.readAsDataURL(file);


            setImage({
                preview: URL.createObjectURL(file),
                raw: file
            });
        }
    };

    const handleButtonClick = () => {
        // Mengklik input file secara programatik
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const getMyDataProfile = async () => {
        const response = await getMyProfile();
        if (!response?.error) {
            setUsers(response?.data)
            loadImage(response?.data.thumbnail);
        }
    }

    const loadImage = async (thumbnail: string) => {
        const imageUrl = `${MINIO}/${thumbnail}`;
        const exists = await checkImageExists(imageUrl);
        setImageExists(exists);
        setSelectedImage(exists ? imageUrl : '/assets/imgs/no-user-image-icon.jpg');
    };

    const uploadImage = async () => {
        const formData = new FormData();
        if (image.raw) {
            formData.append("image", image.raw);
        }

        const response = await uploadMyPic(formData);
        if (response?.code === 200) {
            navigate(`/admin/account`)
        } else {
            showMessage(response?.message, 'error')
        }

    }

    useEffect(() => {
        getMyDataProfile()
    }, [])

    return (
        <Layout title='Upload Foto' showNavBar={true} showNavigation={false}>
            <div className='mt-[4rem]'>
                <div className="mt-4 text-center flex justify-center">
                    <img
                        src={image.preview === "" ? selectedImage : image.preview}
                        alt="Preview"
                        className="rounded-md shadow-md"
                        style={{ maxWidth: '100%', maxHeight: '300px' }}
                    />
                </div>
                <div className='flex gap-2 justify-center mt-4'>
                    <button
                        onClick={() => { handleButtonClick() }}
                        className="text-white btn btn-warning flex items-center">
                        Pilih Foto
                        <FiCamera className='ml-4' />
                    </button>
                    <button
                        onClick={() => { uploadImage() }}
                        className="bg-blue-500 text-white btn flex items-center">
                        Upload
                        <FiUpload className='ml-4' />
                    </button>
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        className="hidden"
                        id="upload-photo"
                    />
                </div>
            </div>
        </Layout>
    );
};

export default UploadPic;